import { render, staticRenderFns } from "./StrapiLettreTechniqueComponent.vue?vue&type=template&id=4657502e"
import script from "./StrapiLettreTechniqueComponent.vue?vue&type=script&lang=js"
export * from "./StrapiLettreTechniqueComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports